// src/api/constants.js

const rawApiRest = process.env.REACT_APP_API_REST;

/**
 * Base URL de la API.
 * - Normaliza espacios y evita slash final duplicado.
 * - Si no está definida, deja string vacío para evitar crashes.
 */
export const apiRest =
  typeof rawApiRest === "string" && rawApiRest.trim().length > 0
    ? rawApiRest.trim().replace(/\/+$/, "")
    : (() => {
        // Aviso no intrusivo: ayuda mucho en despliegues/entornos.
        console.warn("REACT_APP_API_REST is not defined. API calls may fail.");
        return "";
      })();
